import { useState } from 'react';
import DeleteConfirmationModal from '../../../common/DeleteConfirmationModal/DeleteConfirmationModal.js';
import { Locale, OverlayTrigger, Tooltip } from '../../../libraries/index.js';
const BlockTimeSection = ({ openingHourseFormValue, handleEdit, setOpeningHourseFormValue }) => {
    const { t } = Locale();
    const [deleteModal, setDeleteModal] = useState(false);
    const [selectedSlotIndex, setSelectedSlotIndex] = useState(null);
    const message = `${t('teamSetupField.areYouSureYouWantTo')} ${t('ServiceField.deleteSlot')}`
    const handleOpenConfirmationModal = (index) => {
        setDeleteModal(true)
        setSelectedSlotIndex(index)
    }
    const handleClose = () => {
        setDeleteModal(false)
    }

    const deleteBlockSlot = () => {
        const updatedBlockSlots = openingHourseFormValue?.blockTime?.filter((_, index) => index !== selectedSlotIndex)
        setOpeningHourseFormValue((prev) => ({
            ...prev,
            blockTime: updatedBlockSlots
        }))
        setDeleteModal(false)
        setSelectedSlotIndex(null)
    }

    return <>
        <DeleteConfirmationModal
            showModal={deleteModal}
            handleClose={handleClose}
            deleteOperation={deleteBlockSlot}
            message={message}
        />
        <div className='row'>
            <div className='col-11'>
                <div className='block-time-section mt-4 me-4'>
                    <div className='fw-bold'>{t('vendorField.blockTimes')}</div>
                    <table className="table table-heading table-bordered mt-2">
                        <thead className="table-heading-text">
                            <tr className="table-light top-heading-booking">
                                <th>{t('vendorField.sNo')}</th>
                                <th>{t('ServiceField.date')}</th>
                                <th>{t('calender.startTime')}</th>
                                <th>{t('calender.endTime')}</th>
                                <th>{t('ServiceField.action')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(openingHourseFormValue?.blockTime.length === 0) || !(openingHourseFormValue?.blockTime?.length) ? (
                                <tr>
                                    <td colSpan="5" className="text-center">{t('vendorField.noBlockTime')}</td>
                                </tr>
                            ) : (
                                openingHourseFormValue?.blockTime?.length &&  openingHourseFormValue?.blockTime.map((item, index) => (
                                    <tr className={`mt-1 top-heading-booking`} key={item.id}>
                                        <td>{index + 1}</td>
                                        <td>{item.date}</td>
                                        <td>{item.start_time}</td>
                                        <td>{item.end_time}</td>
                                        <td className='d-flex gap-2'>
                                            <div>
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={
                                                        <Tooltip>
                                                            {t('button.editButton')}
                                                        </Tooltip>
                                                    }
                                                >
                                                    <i
                                                        onClick={() => handleEdit(item)}
                                                        className="bi bi-pencil-fill action_edit"
                                                        aria-hidden="true"
                                                    ></i>
                                                </OverlayTrigger>
                                            </div>
                                            <div>
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={
                                                        <Tooltip>
                                                            {t('button.deleteButton')}
                                                        </Tooltip>
                                                    }
                                                >
                                                    <i
                                                        onClick={() => handleOpenConfirmationModal(index)}
                                                        className="bi bi-trash-fill action_delete"
                                                        aria-hidden="true"
                                                    ></i>
                                                </OverlayTrigger>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

    </>
}

export default BlockTimeSection;